import gql from "graphql-tag";
import { PageFragment } from "../fragments/page.fragment";
import { PaymentGatewayFragment } from "../fragments/payment-gateway.fragment";

export const GET_AVAL_PAYMENT_GATEWAY = gql`
  query ($transactionSerialNo: String!) {
    availableReleasePaymentGateways(transactionSerialNo: $transactionSerialNo) {
      ...PaymentGateway
    }
  }

  ${PaymentGatewayFragment}
`;
